import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Mail, Phone, Building2 } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", organization: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/contact", form);
      toast.success("Message received. We will reply within one business day.");
      setForm({ name: "", email: "", phone: "", organization: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send message.");
    } finally { setBusy(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="fade-in-up">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-caption text-[#B91C1C] mb-4">CONTACT</div>
          <h1 className="text-4xl lg:text-5xl font-serif font-bold text-[#0A192F] leading-tight mb-6">Start a conversation.</h1>
          <p className="text-slate-600 leading-relaxed mb-10">For anything containing PHI, PII, VA information, or potentially CUI — please use the secure Case Intake instead. This form is for general inquiries.</p>
          <div className="space-y-5 text-sm">
            <div className="flex items-start gap-3"><Mail className="w-5 h-5 text-[#0A192F] mt-0.5" /><div><div className="text-caption">Email</div><div className="text-slate-700">Ordainedrn@icloud.com</div></div></div>
            <div className="flex items-start gap-3"><Phone className="w-5 h-5 text-[#0A192F] mt-0.5" /><div><div className="text-caption">Response Time</div><div className="text-slate-700">One business day</div></div></div>
            <div className="flex items-start gap-3"><Building2 className="w-5 h-5 text-[#0A192F] mt-0.5" /><div><div className="text-caption">Practice</div><div className="text-slate-700">RN-led Legal Nurse Consulting</div></div></div>
          </div>
        </div>
        <div className="lg:col-span-7">
          <form onSubmit={submit} className="card-federal p-8 space-y-4" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="text-caption block mb-2">Full Name</label>
                <input required value={form.name} onChange={set("name")} data-testid="contact-name" className="w-full border border-slate-300 px-3 py-2.5 focus:border-[#0A192F] outline-none" />
              </div>
              <div>
                <label className="text-caption block mb-2">Email</label>
                <input required type="email" value={form.email} onChange={set("email")} data-testid="contact-email" className="w-full border border-slate-300 px-3 py-2.5 focus:border-[#0A192F] outline-none" />
              </div>
              <div>
                <label className="text-caption block mb-2">Phone (optional)</label>
                <input value={form.phone} onChange={set("phone")} data-testid="contact-phone" className="w-full border border-slate-300 px-3 py-2.5 focus:border-[#0A192F] outline-none" />
              </div>
              <div>
                <label className="text-caption block mb-2">Organization</label>
                <input value={form.organization} onChange={set("organization")} data-testid="contact-org" className="w-full border border-slate-300 px-3 py-2.5 focus:border-[#0A192F] outline-none" />
              </div>
            </div>
            <div>
              <label className="text-caption block mb-2">How can we help?</label>
              <textarea required rows={6} value={form.message} onChange={set("message")} data-testid="contact-message" className="w-full border border-slate-300 px-3 py-2.5 focus:border-[#0A192F] outline-none resize-none" />
            </div>
            <div className="text-[11px] text-slate-500 font-mono uppercase tracking-widest">DO NOT SEND PHI/PII/VA/CUI DATA IN THIS FORM.</div>
            <button disabled={busy} className="btn-navy px-6 py-3 text-[12px] uppercase tracking-widest disabled:opacity-50" data-testid="contact-submit">{busy ? "Sending…" : "Send Message"}</button>
          </form>
        </div>
      </section>
    </div>
  );
}
